import React from 'react';
import { Button } from '@material-ui/core';

const FreeTrialButton = () => {
    return (
        <>
            <span className="font-bold text-center w-full">Need your own On Demand Data Center?</span>
            <div className="flex flex-col items-center justify-center w-full">
                <div className="w-full flex justify-center">
                    <Button
                        variant="contained"
                        color="primary"
                        className="w-full mt-16 button_blue"
                        aria-label="LOG IN"
                        value="legacy"
                        href="https://adaptivecomputing.com/contact-form-request-for-info"
                        target="_blank"
                    >
                        START YOUR FREE TRIAL!
                    </Button>
                </div>
            </div>
        </>
    );
};

export default FreeTrialButton;
